module.exports = __webpack_public_path__ + "static/img/Bachelor_010525.9d588ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010525.jpg
// module id = 180
// module chunks = 0